import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=6910a061&scoped=true&"
import script from "./IdCard.vue?vue&type=script&lang=ts&"
export * from "./IdCard.vue?vue&type=script&lang=ts&"
import style0 from "./IdCard.vue?vue&type=style&index=0&id=6910a061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910a061",
  null
  
)

export default component.exports